import { RequestDataModel } from '@ktvs8/gocoo-engine-front-end';
import { getDay, getToday } from './Program-test-data';

/**
 * 発注書のテストデータ
 */
export const OrderSheetTestData = [
  {
    TicketType: 'OrderSheet',
    TicketKey: getDay(2) + '#testData-1111-1111-1111',
    Active: true,
    OrderdUserEMailAddress: 'test@co.jp',
    MProgramTicketKey: getDay(2) + '#AddToday3',
    MProgramProgramName: 'テスト',
    MProgramOrderTicketKey: getDay(2) + '#AddToday3',
    OrderContent: '黒炎弾',
    OrderSheetFormat: 'StreamContents',
    MSupplierTicketKey: 'test@co.jp#EmailAddress1',
    SupplierName: 'インダストリアル・イリュージョン社',
    OrderDate: getDay(2),
    ProgramName: '黒い悪魔の竜',
    Category: 'Sports',
    CornerTitle: '黒炎弾',
    Spec_Type: 'VTR',
    Spec_LiveTime: '00:00:00',
    Spec_RegluarType: 'Week',
    Spec_Count: '2',
    Spec_TotalCount: '',
    Spec_StreamCount: '',
    Spec_StreamTime: '',
    Spec_Other: '',
    DeliveryForm: '赤い目を持つ竜と悪魔の召喚を融合',
    OnairDates: getDay(2),
    PreReceiptDate_Type: 'BeforeOnairdate',
    PreReceiptDate_CountBeforeOnairdate: '1',
    PreReceiptDate_DirectDate: '',
    DeliveryLocation: 'デュエルディスク',
    ReceiptDate_Type: 'Direct',
    ReceiptDate_CountBeforeOnairdate: '',
    ReceiptDate_DirectDate: getDay(-4),
    PriceType: 'Total',
    Price: '100000',
    PaymentDeadline: getDay(5),
    PaymentMethod: 'モンスターカードと魔法カード',
    CopyrightAttribution: '武藤遊戯 + 城之内勝也',
    OrdererCompany: 'インダストリアル・イリュージョン社',
    OrdererDept: '社長',
    OrdererName: 'ペガサス・J・クロフォード ',
    PendingReason_Price: '融合カードが無い',
    DecisionDate_Price: '',
    PendingReason_OnairDate: getDay(8),
    DecisionDate_OnairDate: getDay(9),
    PendingReason_Other: '迷宮',
    DecisionDate_Other: '',
    ActualReceiptDate_Type: 'Onairdate',
    ActualReceiptDate_DirectDate: '',
    PendingSupplement: ['テキスト', 'イラスト'],
  },
  {
    TicketType: 'OrderSheet',
    TicketKey: getDay(3) + '#testData-1111-1111-1112',
    Active: true,
    OrderdUserEMailAddress: 'abc@co.jp',
    MProgramTicketKey: getToday() + '#Today',
    MProgramProgramName: '死者蘇生',
    MProgramOrderTicketKey: 'test##########',
    OrderContent: '黒い魔術',
    OrderSheetFormat: 'Illust',
    MSupplierTicketKey: 'test@co.jp#EmailAddress1',
    SupplierName: 'インダストリアル・イリュージョン社',
    OrderDate: getDay(4),
    ProgramName: '黒い魔術師',
    Category: 'Variety',
    CornerTitle: '黒い魔術',
    Spec_Type: 'bate',
    Spec_LiveTime: '00:00:00',
    Spec_RegluarType: 'Month',
    Spec_Count: '2',
    Spec_TotalCount: '',
    Spec_StreamCount: '',
    Spec_StreamTime: '',
    Spec_Other: '',
    DeliveryForm: '生贄が２体必要',
    OnairDates: getDay(5),
    PreReceiptDate_Type: 'BeforeOnairdate',
    PreReceiptDate_CountBeforeOnairdate: '1',
    PreReceiptDate_DirectDate: '',
    DeliveryLocation: 'デュエルディスク',
    ReceiptDate_Type: 'Direct',
    ReceiptDate_CountBeforeOnairdate: '',
    ReceiptDate_DirectDate: getDay(-4),
    PriceType: 'Total',
    Price: '100000',
    PaymentDeadline: getDay(5),
    PaymentMethod: 'モンスターカード',
    CopyrightAttribution: '武藤遊戯',
    OrdererCompany: '初期から存在',
    OrdererDept: 'おじいちゃん',
    OrdererName: '武藤双六',
    PendingReason_Price: '魔法の帽子',
    DecisionDate_Price: '',
    PendingReason_OnairDate: getDay(6),
    DecisionDate_OnairDate: getDay(9),
    PendingReason_Other: 'バトルシティ',
    DecisionDate_Other: '',
    ActualReceiptDate_Type: 'Onairdate',
    ActualReceiptDate_DirectDate: '',
    PendingSupplement: [],
  },
  {
    TicketType: 'OrderSheet',
    TicketKey: getDay(3) + '#testData-1111-1111-1113',
    Active: true,
    OrderdUserEMailAddress: 'seto@co.jp',
    MProgramTicketKey: getDay(2) + '#AddToday4',
    MProgramProgramName: '',
    MProgramOrderTicketKey: '',
    OrderContent: '滅びの破壊光線',
    OrderSheetFormat: 'Illust',
    MSupplierTicketKey: 'tanaka@co.jp#EmailAddress2',
    SupplierName: '海馬コーポレーション',
    OrderDate: getDay(7),
    ProgramName: '青い目を持つ竜',
    Category: 'Variety',
    CornerTitle: 'いでよ青い目を持つ竜よ',
    Spec_Type: 'bate',
    Spec_LiveTime: '00:00:00',
    Spec_RegluarType: 'Month',
    Spec_Count: '2',
    Spec_TotalCount: '',
    Spec_StreamCount: '',
    Spec_StreamTime: '',
    Spec_Other: '',
    DeliveryForm: '生贄が２体必要',
    OnairDates: getDay(2),
    PreReceiptDate_Type: 'BeforeOnairdate',
    PreReceiptDate_CountBeforeOnairdate: '1',
    PreReceiptDate_DirectDate: '',
    DeliveryLocation: 'デュエルリンク',
    ReceiptDate_Type: 'Direct',
    ReceiptDate_CountBeforeOnairdate: '',
    ReceiptDate_DirectDate: getDay(-4),
    PriceType: 'Total',
    Price: '80000',
    PaymentDeadline: getDay(5),
    PaymentMethod: 'モンスターカード',
    CopyrightAttribution: '海馬モクバ',
    OrdererCompany: '初期から存在',
    OrdererDept: '瀬戸様',
    OrdererName: '社長',
    PendingReason_Price: '',
    DecisionDate_Price: '',
    PendingReason_OnairDate: getDay(6),
    DecisionDate_OnairDate: getDay(9),
    PendingReason_Other: 'バトルシティ',
    DecisionDate_Other: '',
    ActualReceiptDate_Type: 'Onairdate',
    ActualReceiptDate_DirectDate: '',
    PendingSupplement: [],
  },
];

/**
 * 発注書の検索処理
 * @param requestModel
 * @returns
 */
export function filterOrderSheetBySearchDay(requestModel: RequestDataModel) {
  return OrderSheetTestData;
}

export function findOrderSheetBySearchDay(requestModel: RequestDataModel) {
  const ticketKey = requestModel.getRequestData()['condition']['TicketKey'];
  return OrderSheetTestData.find((orderSheet) => {
    return orderSheet.TicketKey === ticketKey;
  });
}
